import ReactDOM from "react-dom";
import React from "react";
import BcfButtons from "./bcfButtons";
import * as SmartDrawings from "../../smartDrawings";
import BcfCheckbox from "./bcfCheckbox";
import BcfSnapshot from './bcfSnapshot';

interface BcfViewsProps {
    checkBoxName: string;
    checkBoxOnClick: (checked: boolean) => void;

    bcf: SmartDrawings.BcfInfo;

    gotoViewpoint: (markupIndex: number, snapshotIndex: number) => void;
    gotoHome: () => void;
}

class BcfViews extends React.Component<BcfViewsProps> {
    constructor(props: BcfViewsProps) {
        super(props);
    }

    render() {
        return (
            <div className="react-content" style={{ width: "100%", gap: "30px", display: "grid" }}>
                <BcfCheckbox name="Ghost hidden items" onClick={checked => this.props.checkBoxOnClick(checked)} />
                <BcfButtons bcf={this.props.bcf}
                    gotoViewpoint={this.props.gotoViewpoint}
                    gotoHome={() => this.props.gotoHome()} />
            </div>
        );
    }
}

export class BcfPanelViews extends Autodesk.Viewing.UI.DockingPanel {

    private readonly viewer: Autodesk.Viewing.GuiViewer3D;

    private readonly contentDiv: HTMLDivElement;
    private reactNode;

    private readonly bcf: SmartDrawings.BcfInfo;
    private extGotoViewpoint: (markupIndex: number, snapshotIndex: number) => void;
    private extGotoHome: () => void;
    private extUseGhosting: (use: boolean) => void;
    private uiButtons: BcfButtons;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D,
        bcf: SmartDrawings.BcfInfo,
        gotoViewpoint: (markupIndex: number, snapshotIndex: number) => void,
        gotoHome: () => void,
        useGhosting: (use: boolean) => void) {
        super((viewer.container as HTMLElement), "SmartDrawings-Panel-Bcf-Views", "Views", null);
        this.viewer = viewer;

        this.container.classList.add("bcf-views-panel");
        
        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.contentDiv.setAttribute("style",
            "display: flex; flex-direction: column; padding: 20px; overflow-y: auto; height: calc(100% - 100px); " +
            "background-color: rgba(34, 34, 34, 0.9);");
        this.container.appendChild(this.contentDiv);

        this.bcf = bcf;
        this.extGotoViewpoint = gotoViewpoint;
        this.extGotoHome = gotoHome;
        this.extUseGhosting = useGhosting;
    }

    setVisible(show: boolean) {
        super.setVisible(show);

        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<BcfViews checkBoxName="Ghost hidden items" checkBoxOnClick={checked => this.extUseGhosting(checked)}
                bcf={this.bcf} gotoViewpoint={this.extGotoViewpoint} gotoHome={() => this.extGotoHome()} />, this.contentDiv);
            this.resizeToContent();
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }
}